module.exports = __webpack_public_path__ + "img/20200614_111131.10d160d6.jpg";